import { render, staticRenderFns } from "./RewardItemSection.vue?vue&type=template&id=79d0753d&scoped=true"
import script from "./RewardItemSection.vue?vue&type=script&lang=ts"
export * from "./RewardItemSection.vue?vue&type=script&lang=ts"
import style0 from "./RewardItemSection.vue?vue&type=style&index=0&id=79d0753d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d0753d",
  null
  
)

export default component.exports